// import React, { useState, useEffect } from 'react';

// interface SubTeamMember {
//   _id: string;
//   createdAt: string;
//   level: number;
//   member: string;
//   name: string;
//   number: string;
//   owner: string;
//   updatedAt: string;
//   __v: number;
// }

// const TeamDetail: React.FC = () => {

//   const [teamDetails, setteamDetails] = useState<SubTeamMember[]>([]);
//   const [searchTerm, setSearchTerm] = useState(""); // State for the search term
//   const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchTerm(event.target.value);
//   };
//   useEffect(()=>{
//        fetchteamDetails()
//   },[])


// const fetchteamDetails = async () => {
//   try {
//     // Fetching team details initiated by the user
//     const response = await fetch(`${API_BASE}/api/subTeam/getSubTeamall`);
//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
//     const data = await response.json();

//     if (data.status === "success" && data.subTeam) {
//       // Converting the team object into an array using Object.values()
//       const teamDetailsArray:any = Object.values(data.subTeam);
//       // Setting the state with the team details array
//       setteamDetails(teamDetailsArray);
//     } else {
//       console.error('Unexpected response structure:', data);
//       setteamDetails([]);
//     }

//   } catch (error) {
//     console.error(`Error fetching team details:`, error);
//     // Clear the state in case of an error
//     setteamDetails([]);
//   }
// };

// const filteredDepositData = teamDetails.filter((item:any) =>
//     item.owner.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     item.member.toLowerCase().includes(searchTerm.toLowerCase())
//   );


//   return (
//     <div>
//       <h1 className="text-2xl font-bold mb-4">team Details</h1>
//         <input
//         type="text"
//         placeholder="Search by owner or member email..."
//         value={searchTerm}
//         onChange={handleSearchChange}
//         className="mb-4 p-2 border rounded"
//       />
//       <div className="h-[690px] overflow-scroll">
//         <table>
//           <thead>
//             <tr>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">S.No.</th>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Owner</th>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Member</th>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Date</th>
//               <th className="py-3 px-8 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">level</th>
//             </tr>
//           </thead>
//           <tbody>
//             {[...filteredDepositData].reverse().map((request: any, index: any) => (
//               <tr key={index + 1}>
//                 <td className="py-3 px-8 border-b border-gray-200">{index + 1}</td>
//                 <td className="py-3 px-8 border-b border-gray-200">{request.owner} </td>
//                 <td className="py-3 px-8 border-b border-gray-200">{request.member}  </td>
//                 <td className="py-3 px-8 border-b border-gray-200">{request.createdAt}  </td>
//                 <td className="py-3 px-8 border-b border-gray-200">
//   {request.level}
// </td>

//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default TeamDetail;

import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API_BASE } from "../config";

interface SubTeamMember {
  _id: string;
  createdAt: string;
  level: number;
  member: string;
  name: string;
  number: string;
  owner: string;
  updatedAt: string;
  investedPlan?: string;
  referrerEmail?: string;
}

const TeamDetail: React.FC = () => {
  const [teamDetails, setTeamDetails] = useState<SubTeamMember[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, totalPages: 0 });


  const fetchTeamDetails = useCallback(async (page: number, limit: number) => {
    try {
      setIsLoading(true);
      // Use server-side pagination
      const response = await axios.get(`${API_BASE}/api/admin/team-details?page=${page}&limit=${limit}`);
      const data = response.data;
      if (data.status === "success" && data.subTeam) {
        const teamDetailsArray: SubTeamMember[] = Array.isArray(data.subTeam)
          ? data.subTeam
          : Object.values(data.subTeam);
        setTeamDetails(teamDetailsArray);
        // Use server pagination data
        if (data.pagination) {
          setPagination(data.pagination);
        }
      } else {
        setTeamDetails([]);
      }
    } catch (error) {
      console.error("Error fetching team details:", error);
      setTeamDetails([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTeamDetails(pagination.page, pagination.limit);
  }, [pagination.page, pagination.limit, fetchTeamDetails]);

  // Client-side filtering only (no pagination here)
  const filteredTeamData = teamDetails.filter(
    (item) =>
      item.owner.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.member.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-6 pb-20">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center">Team Details</h1>

      {/* Search & Limit Section */}
      <div className="mb-6 flex flex-col gap-4">
        <input
          type="text"
          placeholder="Search by owner or member..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full p-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#523680]/20 border-gray-200"
        />

        <div className="flex justify-end">
          <select
            value={pagination.limit}
            onChange={(e) => {
              const newLimit = parseInt(e.target.value);
              setPagination(prev => ({ ...prev, limit: newLimit, page: 1 }));
            }}
            className="w-full sm:w-40 p-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#523680]/20 border-gray-200 bg-white"
          >
            <option value="10">10 / page</option>
            <option value="20">20 / page</option>
            <option value="50">50 / page</option>
            <option value="100">100 / page</option>
          </select>
        </div>
      </div>

      {isLoading ? (
        <p className="text-center text-gray-500">Loading...</p>
      ) : filteredTeamData.length === 0 ? (
        <p className="text-center text-gray-500">No results found.</p>
      ) : (
        <div className="space-y-4">
          {filteredTeamData.map((item, index) => (
            <div key={index} className="bg-white shadow-md rounded-lg p-5 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="flex justify-between items-start mb-4">
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-0.5">Owner</p>
                  <h2 className="text-base font-bold text-[#523680] truncate">{item.owner}</h2>
                </div>
                <div className="flex flex-col items-end gap-2">
                  <span className="px-2.5 py-1 text-xs font-bold bg-[#523680]/10 text-[#523680] rounded-full border border-[#523680]/5 shrink-0">
                    Lvl {item.level}
                  </span>
                  <span className="text-[10px] text-gray-400 font-medium whitespace-nowrap">
                    {new Date(item.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4 border-t border-gray-50">
                <div className="space-y-1">
                  <p className="text-[10px] font-bold uppercase text-gray-400">Member Info</p>
                  <p className="text-sm font-semibold text-gray-700 truncate">{item.name}</p>
                  <p className="text-xs text-gray-500 truncate">{item.member}</p>
                </div>
                <div className="space-y-1">
                  <p className="text-[10px] font-bold uppercase text-gray-400">Contact</p>
                  <p className="text-sm font-semibold text-gray-700">{item.number}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Advanced Pagination Controls */}
      {!isLoading && teamDetails.length > 0 && (
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 mt-8 mb-4">
          <div className="flex items-center space-x-2">
            <button
              onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
              disabled={pagination.page === 1}
              className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 disabled:opacity-50 transition-colors font-medium text-gray-700"
            >
              Previous
            </button>

            <div className="flex items-center space-x-1 shrink-0 overflow-x-auto max-w-[150px] sm:max-w-none no-scrollbar">
              {(() => {
                const pages = [];
                const maxVisible = window.innerWidth < 640 ? 3 : 5;
                let start = Math.max(1, pagination.page - Math.floor(maxVisible / 2));
                let end = Math.min(pagination.totalPages, start + maxVisible - 1);

                if (end - start + 1 < maxVisible) {
                  start = Math.max(1, end - maxVisible + 1);
                }

                if (start > 1) {
                  pages.push(
                    <button
                      key={1}
                      onClick={() => setPagination(prev => ({ ...prev, page: 1 }))}
                      className="w-10 h-10 rounded-lg border hover:bg-gray-50 transition-colors text-gray-600"
                    >
                      1
                    </button>
                  );
                  if (start > 2) pages.push(<span key="dots-start" className="px-1 text-gray-400">...</span>);
                }

                for (let i = start; i <= end; i++) {
                  if (i <= 0) continue;
                  pages.push(
                    <button
                      key={i}
                      onClick={() => setPagination(prev => ({ ...prev, page: i }))}
                      className={`w-10 h-10 rounded-lg border transition-all ${pagination.page === i
                        ? "bg-blue-600 text-white border-blue-600 shadow-md transform scale-105"
                        : "hover:bg-gray-50 text-gray-700"
                        }`}
                    >
                      {i}
                    </button>
                  );
                }

                if (end < pagination.totalPages) {
                  if (end < pagination.totalPages - 1) pages.push(<span key="dots-end" className="px-1 text-gray-400">...</span>);
                  pages.push(
                    <button
                      key={pagination.totalPages}
                      onClick={() => setPagination(prev => ({ ...prev, page: pagination.totalPages }))}
                      className="w-10 h-10 rounded-lg border hover:bg-gray-50 transition-colors text-gray-600"
                    >
                      {pagination.totalPages}
                    </button>
                  );
                }

                return pages;
              })()}
            </div>

            <button
              onClick={() => setPagination(prev => ({ ...prev, page: Math.min(prev.totalPages, prev.page + 1) }))}
              disabled={pagination.page === pagination.totalPages}
              className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 disabled:opacity-50 transition-colors font-medium text-gray-700"
            >
              Next
            </button>
          </div>

          <div className="flex items-center space-x-2 text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-lg border shadow-sm">
            <span>Go to:</span>
            <input
              type="number"
              min="1"
              max={pagination.totalPages}
              className="w-16 p-1 border rounded text-center focus:ring focus:ring-blue-100 outline-none"
              placeholder="#"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const p = parseInt((e.target as HTMLInputElement).value);
                  if (!isNaN(p) && p >= 1 && p <= pagination.totalPages) {
                    setPagination(prev => ({ ...prev, page: p }));
                  }
                }
              }}
            />
            <span className="whitespace-nowrap">of {pagination.totalPages} ({pagination.total} total)</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamDetail;
